import {formsSession} from './formsOfflineSession';

export const startFormsCacheScheduler = (): (() => void) =>
  formsSession.startScheduler();

export const stopFormsCacheScheduler = (): void => formsSession.stopScheduler();

export const isFormsCacheSchedulerStarted = (): boolean =>
  formsSession.isSchedulerStarted();
